export default "__VITE_ASSET__PjXnSkU9__"